/**
 * Main menu
 */

import PubSub from "pubsub-js";

class Menu {

    constructor() {

        this.menuButtons = document.querySelectorAll('.c-menu a');
        this.hamburger = document.getElementById('js-nav-btn');
        this.searchBtn = document.getElementById('js-search-btn');
        let self = this;

        // Mark current page with aria-current="page"
        htmx.on('htmx:pushedIntoHistory', (htmxEvent) => {
            self.manageMenuState(String(htmxEvent.detail.path));
        });

        htmx.on('htmx:historyRestore', (htmxEvent) => {
            self.manageMenuState(String(htmxEvent.detail.path));
        });

        // Page swapping - update the menu state
        htmx.on('htmx:beforeSwap', (htmxEvent) => {
            //self.manageMenuState(String(htmxEvent.detail.path));
        });

        // initial state
        this.manageMenuState(window.location.href);

        // Listen for main menu toggle
        PubSub.subscribe('toggleOpen', (message, btn) => {
            if (btn.id === 'js-nav-btn') {
                let mq = matchMedia('(min-width: 640px)').matches;
                let triggerTarget = document.getElementById('nav-btn-professionals');
                if (triggerTarget && mq) {
                    // open the professionals panel when the main menu is opened, on larger screens
                    triggerTarget.click();
                }
            }
        });
    }

    manageMenuState(requestedUrl) {

        const root = location.protocol + '//' + location.host;

        // normalise requested URL
        if (requestedUrl.startsWith('/')) {
            requestedUrl = root + requestedUrl;
        }

        // Set current page
        for (let i=0; i < this.menuButtons.length; i++) {
            let buttonUrl = this.menuButtons[i].href;
            if (buttonUrl) {
                if (buttonUrl.startsWith('/')) {
                    buttonUrl = root + buttonUrl;
                }
                if (requestedUrl.startsWith(buttonUrl)) {
                    this.menuButtons[i].setAttribute('aria-current', 'page');
                } else {
                    this.menuButtons[i].removeAttribute('aria-current');
                }
            }
        }

        // Close nav panel on page swap, if open
        if (this.hamburger.getAttribute('aria-expanded') === 'true') {
            this.hamburger.click(); // triggers Toggle.doToggle()
        }

        // Close search form on page swap, if open
        if (this.searchBtn.getAttribute('aria-expanded') === 'true') {
            this.searchBtn.click(); // triggers Toggle.doToggle()
        }

    }
}

export default Menu;